import React from 'react';

import './dealer-reviews-loading.scss';

export function DealerReviewsLoading() {
  return (
    <div className="dealer-reviews-loading d-flex justify-content-center my-1">
      <i className="spinner icon-spinner8 me-0_25" title="loading" />
    </div>
  );
}
